import $ from "jquery";
import { __ } from "../utils/i18n.js";
const RPM_PHYSICAL_MEDIA_HINT = __('Real Media Library creates a virtual folder structure. The URLs of uploads do not change when you move the file. Learn more about <a href="https://devowl.io/knowledge-base/real-media-library-physical-folder-structur/" target="_blank">how to automatically move files to physical folders.</a>');
function applyRpmUrlFieldHint(urlSetting) {
    if (window.realPhysicalMedia) {
        return;
    }
    const $urlSetting = $(urlSetting);
    if ($urlSetting.data("rpmHintAdded")) {
        return;
    }
    $urlSetting.data("rpmHintAdded", true);
    const description = $('<p class="description" />');
    $urlSetting.addClass("has-description");
    description.insertAfter($urlSetting);
    description.html(RPM_PHYSICAL_MEDIA_HINT);
}
function applyRpmAttachmentPageHint(section) {
    if (window.realPhysicalMedia) {
        return;
    }
    const $section = $(section);
    if ($section.data("rpmHintAdded")) {
        return;
    }
    $section.data("rpmHintAdded", true);
    const description = $('<p class="description" />');
    description.appendTo($section);
    description.html(RPM_PHYSICAL_MEDIA_HINT);
}
export { applyRpmAttachmentPageHint, applyRpmUrlFieldHint };
